/*
 * Initialize the vue application.
 */
import Vue from 'vue';
import App from '@/App.vue';

/*
 * Initialize bugsnag
 */
import '@/plugins/bugsnag';

/* ============
 * Configuration and bootstrap
 * ============
 *
 * Import and bootstrap the plugins.
 */
import '@/plugins/axios';
import '@/plugins/vuex';
import '@/plugins/vuetify';
import '@/plugins/vuetify-google-autocomple';
import '@/plugins/vee-validate';
import '@/plugins/vue-router';
import '@/plugins/vuex-router-sync';
import '@/plugins/vue-meta';
import { i18n } from '@/plugins/vue-i18n';
import '@/plugins/moment';
import '@/plugins/vue-upload-component';
import '@/plugins/filesize';
import '@/plugins/quilljs';
import '@/plugins/event-notifier';


/*
 * ============
 * Vue Filters
 * ============
 *
 */
import '@/filters';

/* ============
 * Styling
 * ============
 *
 * Import the application styling.
 * Stylus is used as default CSS preprocessor
 *
 * http://stylus-lang.com/
 */
import '@/assets/stylus/main.styl';

/*
 * ============
 * Directives bootstrap
 * ============
 *
 * Bootstrap global directives
 */
import '@/directives';

/*
 * ============
 * Main App
 * ============
 *
 */
import store from '@/store';
import router from '@/router';
import { eventBus } from '@/events';
import overlord from '@/overlord';
import installOverlordEvents from '@/overlord/events';

/*
 * ============
 * Bootstrap modules
 * ============
 *
 */
import '@/design-system/bootstrap';
import '@/modules/site/bootstrap';
import '@/modules/taxonomy/bootstrap';
import '@/modules/form/bootstrap';
import '@/modules/entity/selector/bootstrap';
import '@/modules/bcube-assistant/bootstrap';

import '@/utils/meme-generator';

/*
 * ============
 * Global services
 * ============
 *
 */
import toast from '@/modules/toast/services';

Vue.prototype.toast = toast;

function buildApp(...plugins) {
  const app = new Vue({
    /**
     * The localization plugin.
     */
    i18n,
    /**
     * The router.
     */
    router,
    /**
     * The Vuex store.
     */
    store,
    /**
     * OverlordJS client
     */
    overlord,
    /**
     * Render the app
     */
    render: h => h(App),
  });

  // Configure site plugins
  plugins.forEach(plugin => plugin({
    Vue,
    app,
    store,
    router,
    i18n,
    overlord,
    eventBus,
  }));

  // Configure overlord events
  installOverlordEvents({ store });

  app.$mount('#app');
  return app;
}

export {
  buildApp,
  store,
  router,
  overlord,
  eventBus,
};
